import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

/**
 * Tipo para los roles obtenidos del método `getRoles`.
 */
interface Role {
    id: string;
    name: string;
    permissions: {
        id: string;
        name: string;
        code: string;
    }[];
}

/**
 * Hook para obtener los roles disponibles.
 *
 * @returns Los roles y el estado de la consulta.
 */
export const useGetRoles = (): UseQueryResult<Role[], Error> => {
    return useQuery<Role[], Error>({
        queryKey: ['roles'], // Clave única para la consulta
        queryFn: async () => {
            const response = await usersApi.getRoles();
            return Array.isArray(response.data) ? response.data : [response.data];
        },
    });
};
